import { Text } from '@interco/inter-ui/components/Text'

import * as S from './FeatureTopic.styles'

interface FeatureCardProps {
  icon: JSX.Element
  description: string
}

export const FeatureTopic = ({ icon, description }: FeatureCardProps) => (
  <S.FeatureTopic>
    {icon}
    <Text variant="body-3" weight={400}>
      {description}
    </Text>
  </S.FeatureTopic>
)
